/**
 * Darkens a hex color by a given percentage
 * @param hex Hex color string (e.g., "#FF9400" or "#FF940080")
 * @param percent Percentage to darken (0-100), default 15
 * @returns Darkened hex color string
 */
export const darkenColor = (hex: string, percent = 15): string => {
  // Remove # if present
  const cleanHex = hex.replace("#", "");

  // Parse RGB values
  const r = Number.parseInt(cleanHex.substring(0, 2), 16);
  const g = Number.parseInt(cleanHex.substring(2, 4), 16);
  const b = Number.parseInt(cleanHex.substring(4, 6), 16);

  // Check if alpha channel is present
  const hasAlpha = cleanHex.length === 8;
  const alpha = hasAlpha ? cleanHex.substring(6, 8) : "";

  // Calculate darkened values
  const factor = 1 - percent / 100;
  const newR = Math.round(r * factor);
  const newG = Math.round(g * factor);
  const newB = Math.round(b * factor);

  // Convert back to hex
  const toHex = (value: number) => value.toString(16).padStart(2, "0");

  return `#${toHex(newR)}${toHex(newG)}${toHex(newB)}${alpha}`;
};
